import { render, staticRenderFns } from "./DateCompanie.vue?vue&type=template&id=3661b064&scoped=true&"
import script from "./DateCompanie.ts?vue&type=script&lang=ts&"
export * from "./DateCompanie.ts?vue&type=script&lang=ts&"
import style0 from "./DateCompanie.vue?vue&type=style&index=0&id=3661b064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3661b064",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
